import { render } from "./card-payment.vue?vue&type=template&id=2d65d7b0&scoped=true"
import script from "./card-payment.vue?vue&type=script&lang=js"
export * from "./card-payment.vue?vue&type=script&lang=js"

import "./card-payment.vue?vue&type=style&index=0&id=2d65d7b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d65d7b0"]])

export default __exports__